import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import "../styles/Login.css";
import { login, logout } from "../services/AuthService";
import Logo from "../images/Logo.svg";
import emailIcon from "../images/emailIcon.svg";
import passwordIcon from "../images/passwordIcon.svg";
import NapworksLogo from "../images/NapworksLogo.svg";
import checkBoxUnChecked from "../images/checkBoxUnChecked.svg";
import checkBoxChecked from "../images/checkBoxChecked.svg";
import hiddenEyePasswordIcon from "../images/hiddenEyePasswordIcon.svg";
import showEyePasswordIcon from "../images/showEyePasswordIcon.svg";
const apiUrl = process.env.REACT_APP_API_URL;
//console.log("apiUrl ", apiUrl);

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showRemeberMe, setshowRemeberMe] = useState(false);
  const [message, setMessage] = useState(
    () => sessionStorage.getItem("login_message") || null,
  );

  useEffect(() => {
    if (sessionStorage.getItem("login_message")) {
      sessionStorage.removeItem("login_message");
    }
  }, []);

  const token = localStorage.getItem('token');

    if (!token) {
      //window.location.href = '/';
    } else {
      // Make a request to the server to verify the token
      axios.get(`${apiUrl}/verifyToken`, {
        headers: {
          auth: token,
        },
      })
        .then(response => {
          const { status } = response.data;
          if (status === 1) {
            window.location.href = '/dashboard';
          } else {
            logout();
            showMessage(response.data.message || "Invalid Credentials!");
          }
        })
        .catch(error => {
          logout();
          const message =
            error.response?.data?.message || "Invalid Credentials!";
          showMessage(message);
        });
      }

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    // validationSchema: yup.object({
    //   email: yup.string().email('Invalid email').required('Email is required'),
    //   password: yup.string().required('Password is required'),
    // }),
    onSubmit: (values) => {
      axios
        .post(`${apiUrl}/login`, values, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.data?.status !== 1 || !response.data?.token) {
            showMessage(response.data?.message || "Invalid Credentials!");
            return;
          }

          const token = response.data.token;
          login(token, {
            name: response.data.name,
            image: response.data.image,
            role: response.data.role,
            accountId: response.data.accountId,
            email: response.data.email,
          });
          window.location.href = "/dashboard";
        })
        .catch((error) => {
          const message =
            error.response?.data?.message || "Invalid Credentials!";
          showMessage(message);
        });
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleRememberMeVisibility = () => {
    setshowRemeberMe((prevRememberMe) => !prevRememberMe);
  };

  return (
    <div className="page-container">
      <div className="login-page">
        {/* Logo */}

        <div className="login-card">
          <div className="logo-container">
            <img src={Logo} alt="Logo" className="logo" />
          </div>

          {/* Right side (Form) */}
          <div className="login-form">
            <div className="card-body">
              <h1 className="card-title">Sign in!</h1>
              <form onSubmit={formik.handleSubmit}>
                {/* Email field */}
                <div className="form-group">
                  <div className="form-input-container">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={emailIcon}
                        alt="Email icon"
                      />
                    </div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Email Address"
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className="error-message">{formik.errors.email}</div>
                    )}
                  </div>
                </div>
                {/* Password field */}
                <div className="form-group">
                  <div className="form-input-container">
                    <div className="icon-container">
                      <img
                        className="email-icon"
                        src={passwordIcon}
                        alt="Email icon"
                      />
                    </div>
                    <div className="show-password-label-container">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Password"
                      />
                    </div>
                    <div className="icon-container password-eye-icon" onClick={togglePasswordVisibility}>
                      <img
                        className="email-icon"
                        src={showPassword ? showEyePasswordIcon : hiddenEyePasswordIcon}
                        alt="icon"
                      />
                    </div>
                    </div>
                    <div className="show-password-label-checkbox">
                      <div
                        className={`custom-checkbox ${showPassword ? "checked" : "unchecked"}`}
                        onClick={toggleRememberMeVisibility}
                      >
                        {showRemeberMe ? (
                          <img src={checkBoxChecked} alt="Checked" />
                        ) : (
                          <img src={checkBoxUnChecked} alt="Unchecked" />
                        )}
                      </div>
                      <label className="show-password-label" htmlFor="showPasswordCheckbox" onClick={toggleRememberMeVisibility}>
                        Remember Me
                      </label>
                    </div>
                  
                  {formik.touched.password && formik.errors.password && (
                    <div className="error-message">
                      {formik.errors.password}
                    </div>
                  )}
                </div>
                {message && (
                    <div className="custom-modal">
                    <div className="modal-content">
                      {message}
                    </div>
                  </div>
                  )}
                {/* Submit button */}
                <button type="submit" className="btn btn-primary">
                  Get Started
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <p>
          Powered by <span className="powered-text">NAPWORKS</span>{" "}
          <img src={NapworksLogo} alt="Image" />
        </p>
      </div>
    </div>
  );
};

export default Login;
